import React from 'react';

export default function DashboardEditBar({ isEditMode, onDone }) {
  if (!isEditMode) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '72px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      background: '#0e1a14',
      border: '1px solid rgba(0,229,180,0.4)',
      borderRadius: '24px',
      padding: '10px 20px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.6)',
      animation: 'slideUp 0.25s ease',
      whiteSpace: 'nowrap',
    }}>
      <span style={{
        fontSize: '12px',
        color: '#a0aab4',
        fontFamily: 'sans-serif',
      }}>
        ✦ Hold &amp; drag to reorder
      </span>
      <button
        onClick={onDone}
        style={{
          background: 'linear-gradient(135deg, #00e5b4, #00b8b8)',
          color: '#000',
          border: 'none',
          borderRadius: '16px',
          padding: '7px 16px',
          fontSize: '12px',
          fontWeight: '700',
          cursor: 'pointer',
          fontFamily: 'sans-serif',
          letterSpacing: '0.04em',
        }}
      >
        Done
      </button>
    </div>
  );
}
